import { createContext, useContext } from 'react';
import type { UserSettings } from '@/types/domain';
import type { DataService } from './dataService';

export interface AppDataValue {
  data: DataService;
  settings: UserSettings;
  settingsLoaded: boolean;
  updateSettings: (patch: Partial<UserSettings>) => Promise<void>;
  online: boolean;
  pendingWrites: number;
  syncNow: () => Promise<void>;
}

export const AppDataContext = createContext<AppDataValue | null>(null);

export function useAppData(): AppDataValue {
  const context = useContext(AppDataContext);
  if (!context) throw new Error('useAppData must be used inside <AppDataProvider>');
  return context;
}

export function useDataService(): DataService {
  return useAppData().data;
}

export function useSettings(): UserSettings {
  return useAppData().settings;
}
